module.exports = __webpack_public_path__ + "img/front_page_customers.02096c2b.svg";